module.exports = __webpack_public_path__ + "img/time-icon.06915369.svg";